// import { usePage } from 'frontend/src/contexts/PageUse';
import UtilWrapper from 'frontend/src/components/util/UtilWrapper';
import SidebarContainer from 'frontend/src/components/sidebar/SidebarContainer';
import { usePage } from '../../contexts/PageProvider';
import { TypeBodyM } from '../../styles/mixins';
import { Breakpoint, Columns } from '../../styles/functions';
import SanityContent from '../sanity/content/SanityContent';
import styled from 'styled-components';

function PageInfo() {
  const page = usePage();

  return (
    <Container>
      <SidebarContainer isSticky={true} />
      <Content layout="INFO" blocks={page.infoContent} />
    </Container>
  )
}

const Container = styled(UtilWrapper)`
  margin-top: var(--spacing-page-top);
  margin-bottom: var(--spacing-200);
  
  ${Breakpoint('mobile', 'min')} {
    display: grid;
    gap: 0 var(--gutter);
    grid-template-columns: ${Columns(6)} ${Columns(5)} ${Columns(10)} ${Columns(3)};
  }
  
  ${Breakpoint('tablet', 'min')} {
    grid-template-columns: ${Columns(5)} ${Columns(6)} ${Columns(10)} ${Columns(3)};
  }
`

const Content = styled(SanityContent)`
  ${TypeBodyM}
  grid-column: 3 / 4;
`

export default PageInfo
